/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgHifiIcon } from "../shared/SvgHifiIcon";
var HomeHifiIcon = function HomeHifiIcon(props) {
  return /*#__PURE__*/React.createElement(SvgHifiIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5857 5.99985C23.3667 5.2188 24.6331 5.2188 25.4141 5.99985L38.7004 19.2861L38.7138 19.2995L44.4141 24.9998L42.9999 26.4141L39 22.4142V40.9999C39 42.1044 38.1046 42.9999 37 42.9999H29H20H11C9.89543 42.9999 9 42.1044 9 40.9999V22.414L4.99991 26.4141L3.58569 24.9998L9 19.5855V8.99988C9 8.44759 9.44772 7.99988 10 7.99988H15C15.5523 7.99988 16 8.44759 16 8.99988V12.5855L22.5857 5.99985ZM21 40.9999H28V30.9999H21V40.9999ZM30 40.9999V29.9999C30 29.4476 29.5523 28.9999 29 28.9999H20C19.4477 28.9999 19 29.4476 19 29.9999V40.9999H11V21.4999V20.9999V20.414L23.9999 7.41406L37 20.4142V40.9999H30ZM14.0033 14.5822L11 17.5855V9.99988H14V14.4999C14 14.5276 14.0011 14.5551 14.0033 14.5822Z"
  }));
};
export default HomeHifiIcon;